"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 20.25a8.25 8.25 0 0 0 0-16.5 8.251 8.251 0 0 0 0 16.5m-3.676-7.102a2 2 0 0 0 .909-.034 2.02 2.02 0 0 1-1.616-1.975v-.025c.271.152.583.242.913.252a2.01 2.01 0 0 1-.896-1.676c0-.37.099-.714.271-1.012a5.72 5.72 0 0 0 4.152 2.104 2.015 2.015 0 0 1 3.432-1.837c.459-.091.89-.258 1.279-.489-.149.47-.47.866-.885 1.115q.612-.076 1.157-.317a4.1 4.1 0 0 1-1.005 1.043q.005.129.006.261c0 2.661-2.026 5.731-5.731 5.731a5.7 5.7 0 0 1-3.087-.905q.236.028.481.028c.943 0 1.812-.322 2.501-.861a2.02 2.02 0 0 1-1.881-1.4z"
}), 'TwitterRing'); //# sourceMappingURL=index.js.map
